/* 会员中心接口*/
import { axios } from '@/utils/http'

// 我的报名
export const SignupRecordList = (params) => axios({
  method: 'GET',
  hastoken: true,
  contentType: 'urlencoded'
}, '/member/signup/record?' + params)

// 团队成员
export const teamRecord = (params) => axios({
  method: 'GET',
  hastoken: true,
  contentType: 'urlencoded'
}, '/member/signup/teamRecord?' + params)
// 查询已经退赛的团队成员
export const cancelLog = (params) => axios({
  method: 'GET',
  hastoken: true,
  contentType: 'urlencoded'
}, '/member/apply/cancelLog?' + params)

// 查询单个团队成员
export const selectOneTeamRecord = (params) => axios({
  method: 'GET',
  hastoken: true,
  contentType: 'urlencoded'
}, '/member/signup/selectOneTeamRecord?' + params)

// 查询单个团队成员
export const updateTeamRecord = (params) => axios({
  method: 'POST',
  data: {
    ...params
  },
  noToast: true,
  hastoken: true,
  contentType: 'json'
}, '/member/signup/updateTeamRecord')

// 查询单个团队成员
export const addMember = (params) => axios({
  method: 'POST',
  data: {
    ...params
  },
  noToast: true,
  hastoken: true,
  contentType: 'json'
}, '/competition/signup/addMember')

// 删除团队成员
export const deleteTeamRecord = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  noToast: true,
  hastoken: true
}, '/member/signup/deleteTeamRecord')

export const deleteMember = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  hastoken: true
}, '/competition/signup/deleteMember')

// 我的审核
export const examineRecord = (params) => axios({
  method: 'GET',
  hastoken: true,
  contentType: 'urlencoded'
}, '/member/examine/record?' + params)

// 审核报名
export const auditRecord = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  noToast: true,
  hastoken: true
}, '/member/apply/auditRecord')

export const browserHistory = (params) => axios({
  method: 'POST',
  contentType: 'json'
}, '/member/add/browserHistory?' + params)

// 我的申请
export const applyRecord = (params) => axios({
  method: 'GET',
  hastoken: true,
  contentType: 'urlencoded'
}, '/member/apply/record?' + params)

// 撤回申请
export const cancelRecord = (params) => axios({
  method: 'GET',
  hastoken: true,
  contentType: 'urlencoded'
}, '/member/apply/cancelRecord?' + params)

// 消息管理
export const MessageRecordList = (params) => axios({
  method: 'GET',
  hastoken: true,
  contentType: 'urlencoded'
}, '/member/message/record?' + params)

// 消息已读
export const MessageRead = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  hastoken: true
}, '/member/message/read?' + params)

// 批量标记消息已读
export const batchMarkReadMessage = (ids) => axios({
  method: 'POST',
  hastoken: true,
  contentType: 'jsonArray',
  data: ids
}, '/member/message/batchRead')

// 删除消息
export const deleteMessageRecord = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  hastoken: true
}, '/member/message/delRecord?' + params)

// 批量删除消息
export const batchDeleteMessageRecord = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  hastoken: true
}, '/member/message/delBatchRecord?' + params)

// 老用户赛题列表标记已阅读协议
export const readUserAgreement = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  hastoken: true
}, '/member/agreement/read?' + params)

// 浏览和收藏记录
export const getBrowserAndBookmark = (params) => axios({
  method: 'GET',
  hastoken: true,
  contentType: 'urlencoded'
}, '/member/record/getBrowserAndBookmark?' + params)

// 我的邀请链接生成记录
export const inviteRecord = (params) => axios({
  method: 'GET',
  hastoken: true,
  contentType: 'urlencoded'
}, '/member/invitation/record?' + params)

// 生成邀请链接
export const generateInvitationUrl = (params) => axios({
  method: 'GET',
  hastoken: true,
  contentType: 'urlencoded'
}, '/competition/invitation/generate?url=' + params)

// 删除草稿
export const deleteDraft = (id) => axios({
  method: 'DELETE',
  hastoken: true,
  contentType: 'urlencoded'
}, `/competition/draftDelete?id=${id}`)

// 学生认证
export const studentVerification = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  noToast: true,
  hastoken: true
}, '/auth/verification/student')
// 三要素认证
export const threeVerification = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  noToast: true,
  hastoken: true
}, '/auth/verification/three')
// 提交作品
export const createAtomGitRepo = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  noToast: true,
  hastoken: true
}, '/competition/signup/createAtomGitRepo')
// 完善信息
export const saveOrUpdateUserCompleteInfo = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  noToast: true,
  hastoken: true
}, '/competition/signup/saveOrUpdateUserCompleteInfo')
// 获取用户详细信息
export const getMemberBySourceId = () => axios({
  method: 'GET',
  hastoken: true,
  contentType: 'urlencoded'
}, '/member/getMemberBySourceId')
// 用户信息修改
export const updateMember = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  noToast: true,
  hastoken: true
}, '/member/updateMember')
// 获取收款信息
export const getUserInfoBySignupId = (params) => axios({
  method: 'GET',
  hastoken: true,
  contentType: 'urlencoded'
}, '/competition/signup/getUserInfoBySignupId?' + params)
